import React from 'react';
import Navbar from '@/components/Navbar';
import { useAuth } from '@/contexts/auth/AuthContext';
import { Navigate } from 'react-router-dom';
import { UserRoles } from '@/contexts/auth/enums';
import Footer from '@/components/Footer';

interface ParticipantLayoutProps {
    children: React.ReactNode;
}

const ParticipantLayout: React.FC<ParticipantLayoutProps> = ({ children }) => {
    const { user, isAuthenticated, isLoading } = useAuth();

    // Helper function to check if user is organizer
    const isParticipant = () => {
        if (!user) return false;
        return user.roles.includes(UserRoles.USER);
    };

    // Show loading state while checking authentication
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-medihub-primary"></div>
            </div>
        );
    }

    // Check if user is authenticated and has organizer role
    if (!isAuthenticated || !isParticipant()) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="flex min-h-screen flex-col">
            <Navbar />
            <div className="flex-grow container mx-auto py-6 px-4">
                {children}
            </div>
            <Footer />
        </div>
    );
};

export default ParticipantLayout;
